import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { InputComponent } from '../../utilities/input/input.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { ApiKeyService } from '../../services/api-key.service';
import { CommonModule } from '@angular/common';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CopyTextComponent } from '../../components/copy-text/copy-text.component';
import { DatePickerComponent } from '../../utilities/date-picker/date-picker.component';
import { VaultService } from '../../services/vault.service';
import { PaginationComponent } from "../../utilities/pagination/pagination.component";
import { PermissionService } from '../../services/permissions.service';

@Component({
  selector: 'app-api-key',
  standalone: true,
  imports: [
    DashboardComponent,
    ButtonComponent,
    ModalComponent,
    InputComponent,
    DropdownComponent,
    CommonModule,
    // CopyTextComponent,
    DatePickerComponent,
    CopyTextComponent,
    PaginationComponent
],
  templateUrl: './api-key.component.html',
  styleUrl: './api-key.component.scss',
})
export class ApiKeyComponent {
  addModalOpen: boolean = false;
  deleteModalOpen: boolean = false;
  loading: boolean = false;
  deleteId: string = '';
  emptyState: boolean = false;
  fetchingData: boolean = false;
  limit: number = 0;
  page: number = 0;
  pages: number = 0;
  totalApiKeys: number = 0;
  vaults: any;
  vaultNames = [];
  newApiKey: any = {
    name: '',
    sourceIp: [] as string[],
    expiryDate: new Date(),
    status: 'active',
    vault: '',
  };
  errors: any = {
    name: '',
    sourceIp: [] as string[],
    expiryDate: '',
    status: '',
    vault: '',
  };
  durationOptions: any = [
    '1 Day',
    '1 Week',
    '1 Month',
    '1 Months',
    '6 Months',
    '1 Year',
  ];
  apiKeyCreated: boolean = false;
  generatedApiKey: string = '';
  apiKeys: any;

  canWrite = false;
  canDelete = false;
  canUpdate = false;

  constructor(
    private apiKeyService: ApiKeyService,
    private notification: NzNotificationService,
    private vaultService: VaultService,
    private permissionService: PermissionService
  ) {
    this.getApiKeys();
    this.getVaults();
  }
  ngOnInit() {
    this.canWrite = this.permissionService.hasPermission('Write');
    this.canDelete = this.permissionService.hasPermission('Delete');
    this.canUpdate = this.permissionService.hasPermission('Update');
    console.log(this.canDelete, this.canWrite, this.canUpdate);
  }

  ngOnChanges() {
    this.apiKeyCreated = false;
    this.generatedApiKey = '';
  }

  handleInput(data: { title: string; value: string }) {
    if (data.title == 'vault') {
      this.newApiKey[data.title] = this.getVaultId(data.value);
    } else {
      this.newApiKey[data.title] = data.value;
    }
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  removeSpaces(input: string): string {
    return input?.replace(/\s+/g, '');
  }
  separateByComma(input: string): string[] {
    return input.split(',').map((item) => item.trim());
  }

  openAddModal() {
    this.addModalOpen = true;
  }
  openDeleteModal(id: string) {
    this.deleteModalOpen = true;
    this.deleteId = id;
  }
  closeDeleteModal() {
    this.deleteModalOpen = false;
  }
  closeAddModal() {
    this.addModalOpen = false;
  }
  setApiName = (value: string) => {
    this.newApiKey.name = value;
    if (value === '') {
      this.errors.name = 'Required*';
      return;
    } else {
      this.errors.name = '';
    }
  };

  setExpiryDate = (value: Date) => {
    this.newApiKey.expiryDate = value;
  };
  setIpAddresses = (values: any) => {
    this.newApiKey.sourceIp = this.separateByComma(values);
  };
  validateForm = () => {
    const errors: any = {};
    if (this.newApiKey.name === '') {
      errors.name = 'Required*';
    }
    if (this.newApiKey.vault === '') {
      errors.vault = 'Required*';
    }
    if (this.newApiKey.expiryDate == '') {
      errors.expiresIn = 'Required*';
    }
    console.log(errors);
    return errors;
  };
  getVaults() {
    this.fetchingData = true;
    this.vaultService.getVaults().subscribe({
      next: (res: any) => {
        this.fetchingData = false;
        this.vaults = res.data;
        this.vaultNames = this.vaults.map((vault: { name: any }) => vault.name);
      },
      error: (err) => {
        this.fetchingData = false;
        this.notification.error('Error', 'Failed to fetch vault data', {
          nzClass: 'notification',
        });
      },
    });
  }
  getVaultId(name: string) {
    const vault = this.vaults.find(
      (vault: { name: string }) => vault.name === name
    );
    return vault ? vault._id : null;
  }

  getApiKeys() {
    this.fetchingData = true;
    this.apiKeyService.getApiKeys().subscribe({
      next: (res: any) => {
        console.log(res);
        this.apiKeys = res.data;
        this.fetchingData = false;
        this.totalApiKeys = res?.pagination?.total;
        this.limit = res?.pagination?.limit;
        this.page = res?.pagination?.page;
        this.pages = res?.pagination?.pages;
        if (this.apiKeys.length == 0) this.emptyState = true;
      },
      error: (err) => {
        this.fetchingData = false;
      },
    });
  }
  formatDate(date: string) {
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleString();
  }
  refreshList(){}

  createApiKey = () => {
    console.log(this.newApiKey);
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
      this.loading = true;
      this.apiKeyService.createApiKey(this.newApiKey).subscribe(
        (res: any) => {
          this.generatedApiKey = res.token;
          this.getApiKeys();
          this.apiKeyCreated = true;
          this.notification.success('Success', 'API Key Created', {
            nzClass: 'notification',
          });
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.notification.error('Error', 'Something went wrong', {
            nzClass: 'notification',
          });
        }
      );
    }
  };

  deleteApi = () => {
    this.loading = true;
    this.apiKeyService.deleteApiKey(this.deleteId).subscribe({
      next: (res: any) => {
        this.deleteModalOpen = false;
        this.loading = false;
        this.notification.success('Success', 'API Key Deleted', {
          nzClass: 'notification',
        });
        this.getApiKeys();
      },
      error: (err) => {
        console.log(err);
        this.deleteModalOpen = false;
        this.loading = false;
      },
    });
  };
}
